export default __webpack_public_path__ + "static/49-885a34075f9abee0ac0edd1609c1e1be.png";